import React from "react";
import PropTypes from "prop-types";

import { Row, Col, Container } from "react-bootstrap";
//import { Panel } from "./../panel/panel.jsx";
import GraficaDatosVars from "../datos_vars/graficaDatosVars";
import LabelValue from "../controls/labelValue";
import SelectorVar from "../datos_vars/selectorVar";
import TypesUtils from "../../inumet_js_lib/utils/typesUtils";
import metConstants from "../../inumet_js_lib/model/datosVars/metConstants.js";

import ListaEstaciones from "../../inumet_js_lib/model/estaciones/listaEstaciones";

class FichaEstacion extends React.Component {
    constructor(props) {
        super(props);
        this.containerRef = React.createRef();
        this.handleClickOutside = this.handleClickOutside.bind(this)
        //this.state = { visible: 1, idVar: props.idVarGrafica };
        this.state = {};
        this.onClickClose = this.onClickClose.bind(this);
        this.onSelectVar = this.onSelectVar.bind(this);
        
        let vars = this.props.datosVars.getVars(this.props.idsVariables);
        this.state.vars = vars;
        this.state.idVar = vars.get(0).id;

    }

    onSelectVar(iVar, v) {
        if (v) this.setState({ idVar: v.id });
    }

    onClickClose() {
        this.setState({ idVar: 0 });
        if (this.props.onClose) {
            this.props.onClose();
        }
    }

    componentDidMount() {
        document.addEventListener("mousedown", this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleClickOutside);
    }

    handleClickOutside(event) {
        if (this.containerRef &&
            this.containerRef.current &&
            !this.containerRef.current.contains(event.target)
        ) {
            this.onClickClose();
        }
    }

    render() {
        let minWidth = "500px";
        if (window.innerWidth && window.innerWidth < 1000) {
            minWidth = "370px";
        }

        let stylePanel = {
            position: "absolute",
            zIndex: 999,
            minHeight: this.props.height,
            cursor: "arrow",
            minWidth,
        };
        if (this.props.top) stylePanel.top = this.props.top;
        if (this.props.left) stylePanel.left = this.props.left;

        let subtitulo = null;
        if (this.props.estacion) {
            subtitulo = this.props.estacion.tipoAutomatica
                ? "Automática"
                : "Convencional";
            if (this.props.estacion.getTextoGerenciaReg) {
                let gerenReg = this.props.estacion.getTextoGerenciaReg();
                if (gerenReg) subtitulo += " - " + gerenReg;
            }
        }
        let variable = [];
        if (TypesUtils.notUndefOrNull(this.state.vars)) {
            let varAux = this.state.vars.getById(this.state.idVar);
            if (TypesUtils.notUndefOrNull(varAux)) variable = varAux;
            if (
                TypesUtils.notUndefOrNull(variable) &&
                TypesUtils.notUndefOrNull(
                    this.props.graficasVariablesCombinadas
                ) &&
                TypesUtils.notUndefOrNull(
                    this.props.graficasVariablesCombinadas[variable.id]
                )
            ) {
                variable = this.state.vars.filterByIdsArray(
                    this.props.graficasVariablesCombinadas[variable.id].idsVars
                );
            }
        }
        let listaEstaciones = new ListaEstaciones();
        if (this.props.estacion) {
            listaEstaciones.add(this.props.estacion);
        }

        let varsSelector = this.state.vars.sort();

        varsSelector.list.forEach((v) => {
            if (
                !this.props.datosVars.tieneDatosNoNulos(
                    v.id,
                    this.props.estacion.id
                )
            ) {
                varsSelector.removeById(v.id);
            }
        });
        let labelsMap = {};
        if (TypesUtils.notUndefOrNull(this.props.graficasVariablesCombinadas)) {
            for (let idVar in this.props.graficasVariablesCombinadas) {
                let idVarInt = parseInt(idVar);
                labelsMap[idVarInt] =
                    this.props.graficasVariablesCombinadas[idVarInt].label;
                this.props.graficasVariablesCombinadas[
                    idVarInt
                ].idsVars.forEach((idVarAux) => {
                    let idVarAux2 = parseInt(idVarAux);
                    if (idVarAux2 !== idVarInt)
                        varsSelector.removeById(idVarAux2);
                });
            }
        }
        labelsMap[metConstants.VAR_ID_INTVIENTO_1H_MAX] = "Viento Máx.(km/h)";

        let defaultValueIndexSelVars = varsSelector.indexOf(this.state.idVar);
        if (defaultValueIndexSelVars < 0) defaultValueIndexSelVars = 0;

        let altitud = parseFloat(this.props.estacion.altitud);

        return (

            <Container
                className="shadow"
                ref={this.containerRef}
                style={{
                    height: "100%",
                    backgroundColor: "white", padding: "10px", minWidth,
                    maxWidth: "80%",
                    zIndex: 901,
                }}>
                <i
                    className="fa fa-2x fa-window-close text-purple-darker"
                    style={{
                        position: "relative",
                        float: "right",
                        cursor: "pointer",
                    }}
                    onClick={this.onClickClose}
                />
                <Row>
                    <p className="f-s-26 text-purple-darker f-w-400 mb-2">
                        {this.props.estacion.nombre}
                    </p>
                </Row>
                <Row className=" mb-2">
                    <Col>
                        <span className="f-s-18 text-purple f-w-400">
                            {subtitulo}
                        </span>
                    </Col>
                </Row>
                <Row className="mb-2">
                    <Col>
                        <LabelValue
                            classNamesLabel="mr-3"
                            mb={2}
                            label="Lat"
                            value={parseFloat(
                                this.props.estacion.latitud
                            ).toFixed(3)}
                        />
                    </Col>
                    <Col>
                        <LabelValue
                            classNamesLabel="mr-3"
                            label="Lng"
                            value={parseFloat(
                                this.props.estacion.longitud
                            ).toFixed(3)}
                        />
                    </Col>
                    {Number.isNaN(altitud) ? null : (
                        <Col>
                            <LabelValue
                                label="Altitud"
                                classNamesLabel="mr-3"
                                value={parseFloat(
                                    this.props.estacion.altitud
                                ).toFixed(1)}
                            />
                        </Col>
                    )}
                </Row>

                <div
                    title="Últ. Datos"
                    style={{ padding: "0px !Important" }}
                >
                    <Row className="mb-3">
                        <Col>
                            <SelectorVar
                                variables={varsSelector}
                                defaultValueIndex={defaultValueIndexSelVars}
                                onSelect={this.onSelectVar}
                                incluirUnidad={true}
                                labelsMap={labelsMap}
                                opcionesVars={this.props.opcionesVars}
                            />
                        </Col>
                    </Row>
                    <GraficaDatosVars
                        variable={variable}
                        idsEstaciones={[this.props.estacion.id]}
                        estaciones={[this.props.estacion]}
                        datosVars={this.props.datosVars}
                        opcionesVars={this.props.opcionesVars}
                    />
                </div>
            </Container>

        );
    }
}

FichaEstacion.propTypes = {
    idsVariables: PropTypes.arrayOf(PropTypes.number),
    datosVars: PropTypes.object,
    estacion: PropTypes.object,
    tabUbicacion: PropTypes.bool,
    onClose: PropTypes.func,
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    panelRecepcionDatos: PropTypes.bool,
    graficasVariablesCombinadas: PropTypes.object,
    idVarGrafica: PropTypes.number,
    opcionesVars: PropTypes.array,
    top: PropTypes.number,
    left: PropTypes.number,
};

export { FichaEstacion as default };
